import React from 'react';
import * as css from './css/message';
import ChatMessage from 'enum/ChatMessage';
import {connect} from "react-redux";
import useMyStores from "@/hooks/useMyStores";
import {observer} from "mobx-react";

const Message = ({className, message}) => {
    const {user:userStore} = useMyStores()
    return (
        <css.Message className={className}>
            {message.userType === ChatMessage.FROM ? (
                <css.FromContainer>
                    <css.Content>
                        <div className='nickname'>{userStore.nickname || userStore.username}</div>
                        <div className='message'>{message.content}</div>
                    </css.Content>
                    <css.Avatar/>
                </css.FromContainer>
            ) : (
                <css.ToContainer>
                    <css.Avatar>
                        <img
                            src={require('./img/service-avatar.png')}
                            alt=''
                            className='img'
                        />
                    </css.Avatar>
                    <css.Content>
                        <div className='nickname'>商城智能客服</div>
                        <div className='message'>{message.content}</div>
                    </css.Content>
                </css.ToContainer>
            )}
        </css.Message>
    );
}

export default observer(Message);
